export const userManagementConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getUserList_request: "getUserList_request",
        getUserList_success: "getUserList_success",
        getUserList_failure: "getUserList_failure",

        getUserGroupDetail_request: "getUserGroupDetail_request",
        getUserGroupDetail_success: "getUserGroupDetail_success",
        getUserGroupDetail_failure: "getUserGroupDetail_failure",

        getUserGroupList_request: "getUserGroupList_request",
        getUserGroupList_success: "getUserGroupList_success",
        getUserGroupList_failure: "getUserGroupList_failure",

        getUserGroupPermissionList_request: "getUserGroupPermissionList_request",
        getUserGroupPermissionList_success: "getUserGroupPermissionList_success",
        getUserGroupPermissionList_failure: "getUserGroupPermissionList_failure",

        getUserGroupPermission_request: "getUserGroupPermission_request",
        getUserGroupPermission_success: "getUserGroupPermission_success",
        getUserGroupPermission_failure: "getUserGroupPermission_failure",

        addUser_request: "addUser_request",
        addUser_success: "addUser_success",
        addUser_failure: "addUser_failure",

        updateUser_request: "updateUser_request",
        updateUser_success: "updateUser_success",
        updateUser_failure: "updateUser_failure",

        deleteUser_request: "deleteUser_request",
        deleteUser_success: "deleteUser_success",
        deleteUser_failure: "deleteUser_failure",

        addUserGroup_request: "addUserGroup_request",
        addUserGroup_success: "addUserGroup_success",
        addUserGroup_failure: "addUserGroup_failure",

        updateUserGroup_request: "updateUserGroup_request",
        updateUserGroup_success: "updateUserGroup_success",
        updateUserGroup_failure: "updateUserGroup_failure",

        deleteUserGroup_request: "deleteUserGroup_request",
        deleteUserGroup_success: "deleteUserGroup_success",
        deleteUserGroup_failure: "deleteUserGroup_failure",

        addUserGroupMapping_request: "addUserGroupMapping_request",
        addUserGroupMapping_success: "addUserGroupMapping_success",
        addUserGroupMapping_failure: "addUserGroupMapping_failure",

        removeUserGroupMapping_request: "removeUserGroupMapping_request",
        removeUserGroupMapping_success: "removeUserGroupMapping_success",
        removeUserGroupMapping_failure: "removeUserGroupMapping_failure",

        addPermission_request: "addPermission_request",
        addPermission_success: "addPermission_success",
        addPermission_failure: "addPermission_failure",

        removePermission_request: "removePermission_request",
        removePermission_success: "removePermission_success",
        removePermission_failure: "removePermission_failure",
    }

    let obj_formatted = {};
    let domain = "distributorPortal.userManagement/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}